jQuery(document).ready(function($) {
	$('#show-more-ranking-table').click(function(event) {
        $('.ranking-table__row').removeClass('is-hidden');
        $('.ranking-table__row').addClass('is-visible');
        $('.ranking-table__expand').addClass('is-hidden');

        event.preventDefault();
	});
});
